/* Four Branches — homepage behaviour (loaded only by layout/fb-home.liquid) */
(function () {
  var root = document.documentElement;

  /* rem scaling uses 100vw; subtract the scrollbar so the layout never overflows */
  function setScrollbar() {
    var sbw = Math.max(0, window.innerWidth - root.clientWidth);
    root.style.setProperty('--fb-sbw', sbw + 'px');
  }
  setScrollbar();
  window.addEventListener('resize', setScrollbar, { passive: true });
  window.addEventListener('load', setScrollbar);

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    /* (Header menu behaviour lives in fb-chrome.js) */

    /* Video: autoplay muted while in view + unmute button */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-fb-video-auto]').forEach(function (wrap) {
      var v = wrap.querySelector('video');
      var btn = wrap.querySelector('.fb-video__sound');
      if (!v) return;
      v.muted = true;
      v.setAttribute('muted', '');
      function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      if (!reduceMotion && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; play(); }
            else if (!v.paused) v.pause();
          });
        }, { threshold: 0.25 }).observe(wrap);
      }
      if (btn) btn.addEventListener('click', function () {
        v.muted = !v.muted;
        if (!v.muted && v.paused) play();
        wrap.classList.toggle('is-unmuted', !v.muted);
        btn.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        btn.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
      });
    });

    /* Video: inject the player on click */
    document.querySelectorAll('[data-fb-video]').forEach(function (wrap) {
      var play = wrap.querySelector('.fb-video__play');
      var tpl = wrap.querySelector('template');
      if (!play || !tpl) return;
      play.addEventListener('click', function () {
        var media = wrap.querySelector('.fb-video__media');
        media.appendChild(tpl.content.cloneNode(true));
        wrap.classList.add('is-playing');
        var v = media.querySelector('video');
        if (v) { v.play().catch(function () {}); v.focus(); }
      });
    });

    /* Newsletter: require the 21+ consent box */
    document.querySelectorAll('[data-fb-newsletter]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var box = form.querySelector('input[type="checkbox"][data-required]');
        var msg = form.querySelector('[data-fb-consent-msg]');
        if (box && !box.checked) {
          e.preventDefault();
          if (msg) msg.hidden = false;
          box.focus();
        }
      });
    });
  });
})();
